import PropTypes from "prop-types";

export const HeadingCarouselProps = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  icon: PropTypes.node,
  viewAllLink: PropTypes.string,
  onViewAllClick: PropTypes.func,
  onPrev: PropTypes.func,
  onNext: PropTypes.func,
  showArrowsOnMobile: PropTypes.bool,
};
